import { useRef, useEffect } from "react";
import "./sponsors.css";

import carbon from "../img/carbon.png";
import printajmi from "../img/printajmi.jpeg";
import datacol from "../img/datacol.png";
import partes from "../img/partes.png";
import spfolije from "../img/spfolije.png";
import zzip from "../img/zzip.png";
import stubicke from "../img/stubicke.png";
import fico from "../img/fico.jpg";
import pik from "../img/pik.png";
import arhiv from "../img/arhiv.png";
import mimb from "../img/mimb.jpeg";
import hrbic from "../img/hrbic.jpeg";





export default function Sponsors() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;

    const update3D = () => {
      const cards = track.querySelectorAll(".sponsor");
      const center = window.innerWidth / 2;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;

        const dist = (cardCenter - center) / center;

        const rotateY = dist * 14;
        const scale = 1 - Math.abs(dist) * 0.2;

        card.style.transform = `
          perspective(1000px)
          rotateY(${rotateY}deg)
          scale(${scale})
        `;

        card.style.opacity = 1 - Math.abs(dist) * 0.3;
      });

      requestAnimationFrame(update3D);
    };

    update3D();
  }, []);

  const logos = [carbon, printajmi, datacol, partes, spfolije, zzip, stubicke, pik, arhiv, mimb, hrbic];

  return (
    <div className="sponsors-wrap">
      <h2 className="sponsors-title">SPONZORI & PARTNERI</h2>

      <div className="marquee">
        <div className="track" ref={trackRef}>
          {[...logos, ...logos].map((logo, i) => (
            <div className="sponsor" key={i}>
              <img
                src={logo}
                alt="sponsor"
                className={logo === carbon ? "logo-carbon" : ""}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}